import { add, parse, parseISO, format, differenceInCalendarYears, differenceInCalendarMonths, getMonth } from 'date-fns';
const zeroDate = new Date(0);
// needs to match YpsilonWeb.ViewHelpers.datepicker_date_format_string
const dateFormat = 'dd.MM.yyyy';
const dateISOFormat = 'yyyy-MM-dd';
// needs to match YpsilonWeb.ViewHelpers.datepicker_datetime_format_string
const timeFormat = 'HH:mm';
const datetimeFormat = `${dateFormat} ${timeFormat}`;
const timeISOFormat = 'HH:mm:ss';
const fullMonthFormat = 'MMMM';
function stringToDate(string) {
    return parse(string, dateFormat, zeroDate);
}
function isoStringToDate(string) {
    return parseISO(string);
}
function stringToDatetime(string) {
    return parse(string, datetimeFormat, zeroDate);
}
function isoStringToDatetime(string) {
    return parseISO(string);
}
function dateToString(date) {
    return format(date, dateFormat);
}
function dateToISOString(date) {
    return format(date, dateISOFormat);
}
function datetimeToString(date) {
    return format(date, datetimeFormat);
}
function datetimeToISOString(date) {
    return format(date, dateISOFormat) + 'T' + format(date, timeISOFormat);
}
function getDatePlaceholder(locale) {
    if (locale === 'en') {
        return dateFormat.toLowerCase();
    }
    else if (locale === 'de') {
        return dateFormat.replace('dd', 'tt').replace('yyyy', 'jjjj').toLowerCase();
    }
    else {
        return dateToString(new Date('1999-12-30'));
    }
}
function getDatetimePlaceholder(locale) {
    if (locale === 'en') {
        return datetimeFormat.toLowerCase().replace('hh:mm', 'HH:MM');
    }
    else {
        // no format string placeholder for German because I don't want to show "SS" for hours...
        return datetimeToString(new Date('1999-12-30T16:30'));
    }
}
function getMonthsAndYearsOptions(minDate, maxDate, locale) {
    let months;
    const yearStart = minDate || parse('01.01.1900', dateFormat, zeroDate);
    const yearEnd = maxDate || parse('01.01.2100', dateFormat, zeroDate);
    if (differenceInCalendarYears(yearEnd, yearStart) === 0) {
        months = Array.from({ length: 1 + differenceInCalendarMonths(yearEnd, yearStart) }).map((_el, index) => {
            const date = add(yearStart, { months: index });
            return { name: format(add(yearStart, { months: index }), fullMonthFormat, { locale }), index: getMonth(date) };
        });
    }
    else {
        months = Array.from({ length: 12 }).map((_el, index) => {
            const date = parse(`01.${index + 1}.1999`, dateFormat, zeroDate);
            return { name: format(date, fullMonthFormat, { locale }), index: getMonth(date) };
        });
    }
    const years = Array.from({ length: 1 + differenceInCalendarYears(yearEnd, yearStart) }).map((_el, index) => format(add(yearStart, { years: index }), 'yyyy', { locale }));
    return { months, years };
}
// accepts a Date object, discards its local timezone offset vaue,
// and uses its local date and time values to create a new Date object
// with the value interpreted in UTC timezone
function asUTCDate(date) {
    const UTCDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
    return UTCDate;
}
export { asUTCDate, timeFormat, dateFormat, datetimeFormat, getDatePlaceholder, getDatetimePlaceholder, stringToDate, isoStringToDate, stringToDatetime, isoStringToDatetime, dateToString, dateToISOString, datetimeToString, datetimeToISOString, getMonthsAndYearsOptions, zeroDate };
